const CODE_BEHAVIOUR = {
  E1: { canRead: true, canCreate: true, canUpdate: true, canDelete: true },
  E2: { canRead: true, canCreate: true, canUpdate: true, canDelete: true },
  E3: { canRead: true, canCreate: true, canUpdate: true, canDelete: true },
  E4: { canRead: true, canCreate: true, canUpdate: true, canDelete: false },
  E5: { canRead: true, canCreate: true, canUpdate: true, canDelete: false },
  P1: { canRead: true, canCreate: false, canUpdate: true, canDelete: false },
  P2: { canRead: true, canCreate: false, canUpdate: true, canDelete: false },
  P3: { canRead: true, canCreate: false, canUpdate: true, canDelete: false },
  P4: { canRead: true, canCreate: false, canUpdate: true, canDelete: false },
  P5: { canRead: true, canCreate: false, canUpdate: true, canDelete: false },
  R1: { canRead: true, canCreate: false, canUpdate: false, canDelete: false },
  R2: { canRead: true, canCreate: false, canUpdate: false, canDelete: false },
  R3: { canRead: true, canCreate: false, canUpdate: false, canDelete: false },
  R4: { canRead: true, canCreate: false, canUpdate: false, canDelete: false },
  R5: { canRead: true, canCreate: false, canUpdate: false, canDelete: false },
  N: { canRead: false, canCreate: false, canUpdate: false, canDelete: false },
};

const ROLE_OBJECT_MATRIX = {
  SuperUser: {
    USERS: "E1",
    LESSONS: "E1",
    QUIZZES: "E1",
    TASKS: "E1",
    SURVEYS: "E1",
    SUCCESS_STORIES: "E1",
    GROUPS: "E1",
    FEEDBACK: "E1",
    INTERACTIONS: "E1",
    LESSON_ACTIVITIES: "E1",
    COMMUNITY_PRIORITIES: "E1",
    REVIEWS: "E1",
    CONSENTS: "E1",
    ADMIN_CONFIGS: "E1",
    LOGS: "E1",
    FORMS: "E1",
  },
  RegIntlOrgStaff: {
    USERS: "E2",
    LESSONS: "E1",
    QUIZZES: "R1",
    TASKS: "E2",
    SURVEYS: "E2",
    SUCCESS_STORIES: "E2",
    GROUPS: "E2",
    FEEDBACK: "E2",
    INTERACTIONS: "E2",
    LESSON_ACTIVITIES: "E2",
    COMMUNITY_PRIORITIES: "E2",
    REVIEWS: "E2",
    CONSENTS: "E2",
    ADMIN_CONFIGS: "E2",
    LOGS: "E1",
    FORMS: "E2",
  },
  IntlOrgStaff: {
    USERS: "E3",
    LESSONS: "R1",
    QUIZZES: "R1",
    TASKS: "E3",
    SURVEYS: "E3",
    SUCCESS_STORIES: "E3",
    GROUPS: "E3",
    FEEDBACK: "E3",
    INTERACTIONS: "E3",
    LESSON_ACTIVITIES: "E3",
    COMMUNITY_PRIORITIES: "E3",
    REVIEWS: "R1",
    CONSENTS: "E3",
    ADMIN_CONFIGS: "E3",
    LOGS: "R1",
    FORMS: "E3",
  },
  LclOrgStaff: {
    USERS: "R4",
    LESSONS: "R1",
    QUIZZES: "R1",
    TASKS: "E4",
    SURVEYS: "E4",
    SUCCESS_STORIES: "E4",
    GROUPS: "E4",
    FEEDBACK: "E4",
    INTERACTIONS: "E4",
    LESSON_ACTIVITIES: "E4",
    COMMUNITY_PRIORITIES: "E4",
    REVIEWS: "R5",
    CONSENTS: "E4",
    ADMIN_CONFIGS: "N",
    LOGS: "R4",
    FORMS: "E4",
  },
  ComVol: {
    USERS: "R5",
    LESSONS: "R1",
    QUIZZES: "R1",
    TASKS: "E5",
    SURVEYS: "R5",
    SUCCESS_STORIES: "E5",
    GROUPS: "E5",
    FEEDBACK: "E5",
    INTERACTIONS: "E5",
    LESSON_ACTIVITIES: "E5",
    COMMUNITY_PRIORITIES: "E5",
    REVIEWS: "R5",
    CONSENTS: "P5",
    ADMIN_CONFIGS: "N",
    LOGS: "N",
    FORMS: "P5",
  },
  GuestUser: {
    USERS: "N",
    LESSONS: "R1",
    QUIZZES: "N",
    TASKS: "N",
    SURVEYS: "R5",
    SUCCESS_STORIES: "R5",
    GROUPS: "N",
    FEEDBACK: "N",
    INTERACTIONS: "N",
    LESSON_ACTIVITIES: "N",
    COMMUNITY_PRIORITIES: "N",
    REVIEWS: "N",
    CONSENTS: "N",
    ADMIN_CONFIGS: "N",
    LOGS: "N",
    FORMS: "N",
  },
};

function normalizeRole(value) {
  const raw = typeof value === "string" ? value.trim() : "";
  const compact = raw.replace(/[\s_-]+/g, "").toLowerCase();
  if (compact === "superuser") return "SuperUser";
  if (compact === "regintlorgstaff" || compact === "regintorg" || compact === "regintorgstaff") return "RegIntlOrgStaff";
  if (compact === "intlorgstaff" || compact === "inorgstaff" || compact === "intorgstaff") return "IntlOrgStaff";
  if (compact === "lclorgstaff" || compact === "localorgstaff" || compact === "lclorg") return "LclOrgStaff";
  if (compact === "comvol" || compact === "level5comvol") return "ComVol";
  if (compact === "guestuser" || compact === "guest") return "GuestUser";
  return raw;
}

export function isAdminRole(role) {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === "SuperUser" || normalizedRole === "RegIntlOrgStaff";
}

function normalizePermissionCode(value) {
  if (typeof value !== "string") return null;
  const code = value.trim().toUpperCase();
  return Object.prototype.hasOwnProperty.call(CODE_BEHAVIOUR, code) ? code : null;
}

function resolveCodeFromClaims(permissions, objectKey) {
  if (!permissions || typeof permissions !== "object" || Array.isArray(permissions)) {
    return null;
  }

  const objectValue = normalizePermissionCode(permissions[objectKey]);
  if (objectValue) return objectValue;

  return null;
}

function resolveCodeFromRole(role, objectKey) {
  const roleMap = ROLE_OBJECT_MATRIX[normalizeRole(role)] || {};
  return normalizePermissionCode(roleMap[objectKey]) || "N";
}

export function resolvePermissionCode({ role, permissions, objectKey }) {
  return resolveCodeFromClaims(permissions, objectKey) || resolveCodeFromRole(role, objectKey);
}

export function canAccessObject({ role, permissions, objectKey, operation = "read" }) {
  const code = resolvePermissionCode({ role, permissions, objectKey });
  const behaviour = CODE_BEHAVIOUR[code] || CODE_BEHAVIOUR.N;

  if (operation === "create") return behaviour.canCreate;
  if (operation === "update") return behaviour.canUpdate;
  if (operation === "delete") return behaviour.canDelete;
  return behaviour.canRead;
}
